export default __webpack_public_path__ + "static/media/WeatherAppLite.29b14d7b.png";